import {Fragment} from 'react';
import {useSelector} from 'react-redux';
import {useLocation, Navigate} from 'extensions/navigation';
import {isNative, isPreview, isLocal, getEnvironment} from 'utils/platform';
import {Splash} from 'interface/stacks/Splash';
import {Login} from 'interface/stacks/Login';

import * as app from 'store/slices/app';

export default () => {
  const location = useLocation();
  const isLoggedIn = useSelector(app.selectors.isLoggedIn);
  const destination = location.state?.from?.pathname || '/folder/myfiles';
  const hasExternalLogin = !isNative() && !isPreview() && !isLocal();

  // Web login
  if (hasExternalLogin) {
    // If user is already logged in, navigate to the destination
    if (isLoggedIn) {
      return <Navigate to={destination} state={{from: undefined}} replace/>
    }
    // Otherwise, redirect to the web login page
    window.location.href = `https://${getEnvironment()}.mediafire.com/login/`;
    return <Splash/>;
  }

  // Native login
  return (
    <Fragment>
      {isLoggedIn
        ? <Navigate to={destination} state={{from: undefined}} replace/>
        : <Login/>
      }
    </Fragment>
  );
}
